import script from "./about.vue?vue&type=script&setup=true&lang=js"
export * from "./about.vue?vue&type=script&setup=true&lang=js"

import "./about.vue?vue&type=style&index=0&id=518e5732&lang=scss"

const __exports__ = script;

export default __exports__